/* unplugin-vue-components disabled */import script from "./XTreeSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./XTreeSelect.vue?vue&type=script&setup=true&lang=ts"

import "./XTreeSelect.vue?vue&type=style&index=0&id=50186b02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50186b02"]])

export default __exports__